import React, { Component } from 'react';
import Card from 'react-bootstrap/Card';
import Badge from 'react-bootstrap/Badge';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import ListGroup from 'react-bootstrap/ListGroup';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';

var firebase = require('firebase/app');
require('firebase/auth');
require('firebase/firestore');

export class MyQA extends Component {
  constructor(props) {
    super(props);

    this.openQAModal = this.openQAModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.getReplies = this.getReplies.bind(this);

    this.db = firebase.firestore();

    this.state = {
      prodId: this.props.qaLoc.split('/')[0],
      qaId: this.props.qaLoc.split('/')[1],
      qaCreator: '',
      qaText: '',
      replyText: '',
      replies: [],
      showModal: false,
      softies: 0,
    };
  }

  componentDidMount() {
    let _replies = [];
    let _this = this;
    console.log(this.state.qaId);
    var qaRef = this.db
      .collection('software_pages')
      .doc(this.state.prodId)
      .collection('qas')
      .doc(this.state.qaId);
    qaRef
      .get()
      .then(doc => {
        if (doc.exists) {
          _this.setState({
            qaCreator: doc.data().qaCreator,
            qaText: doc.data().qaText,
            softies: doc.data().softies,
            qaAnswered: doc.data().qaAnswered,
          });
        }
        qaRef
          .collection('replies')
          .get()
          .then(query => {
            query.forEach(doc2 => {
              _replies = _replies.concat(doc2.data());
            });
            // Always udpate state in THEN after the data has been loaded
            _this.setState({ replies: _replies });
          });
        this.props.incrementSofties(this.state.softies);
      })
      .catch(err => console.log('Error accessing data'));
  }

  getReplies() {
    return this.state.replies.map(reply => (
      <ListGroup.Item as="li">
        <div>
          <Card.Subtitle> {reply.replyCreator} replied </Card.Subtitle>
          <Card.Body style={headerMain}>
            {reply.replyText}
            <div style={alignTopRight}></div>
          </Card.Body>
        </div>
      </ListGroup.Item>
    ));
  }

  openQAModal() {
    this.setState({
      showModal: true,
    });
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
      showAlert: false,
    });
  }

  render() {
    return (
      <div>
        <div>
          <Card
            border={this.state.qaAnswered ? 'success' : 'warning'}
            body
            style={{ margin: '0px 8px 0px 8px' }}
          >
            <Card.Subtitle> {this.state.qaCreator} posted </Card.Subtitle>
            <Card.Body style={headerMain}>
              {this.state.qaText}
              <div style={alignTopRight}>
                <i
                  className="fas fa-angle-double-right"
                  style={symbolStyle}
                  onClick={this.openQAModal}
                ></i>
              </div>
              <Card.Text style={{ margin: '20px 0px 0px 0px' }}>
                <i> {'Softies: ' + this.state.softies} </i>
              </Card.Text>
            </Card.Body>
          </Card>

          <Modal
            size="lg"
            centered
            show={this.state.showModal}
            onHide={() => this.setState({ showModal: false })}
          >
            <Modal.Header closeButton style={headerMain}>
              <Modal.Title>Q. {this.state.qaText}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <ListGroup as="ul">
                <this.getReplies />
              </ListGroup>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    );
  }
}

const headerMain = {
  position: 'relative',
};

const alignTopRight = {
  position: 'absolute',
  top: '50%',
  right: '0.5%',
  msTransform: 'translate(-0.5%, -50%)',
  transform: 'translate(-0.5%, -50%)',
};

const softieRight = {
  position: 'absolute',
  top: '3px',
  right: '12px',
};

const symbolStyle = {
  fontSize: '1.75em',
  color: 'gray',
};

export default MyQA;
